import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-icon-nav-43",
  "use": "icon-icon-nav-43-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-icon-nav-43\"><path d=\"M192 698.688V832h133.312l393.216-393.216-133.312-133.312L192 698.688z m629.632-362.944a35.392 35.392 0 0 0 0-50.176l-83.2-83.2a35.392 35.392 0 0 0-50.176 0L623.232 267.52l133.312 133.312 65.088-65.024z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/svg/icon-nav-43.svg
// module id = 88XY
// module chunks = 3